import { FC, lazy, Suspense } from "react";
import {
  Navigate,
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";

import ProtectedRoute from "./ProtectedRoute";
import { getToken } from "@/localStorage/utils";
import { pages } from "@/routes/constants";

const RoutesLazy = lazy(() => import("./AppRoutes"));
const LoginRoutesLazy = lazy(() => import("@/routes/AuthRoutes"));

const UnknownPathRedirect: FC = () => {
  const isAuthUser = getToken();
  return isAuthUser ? (
    <Navigate to={`/app/${pages.securityAwareness}`} replace />
  ) : (
    <Navigate to={`/auth/${pages.login}`} replace />
  );
};

const router = createBrowserRouter([
  {
    path: "/auth/*",
    element: (
      <ProtectedRoute isAuthRoute>
        <Suspense fallback={<></>}>
          <LoginRoutesLazy />
        </Suspense>
      </ProtectedRoute>
    ),
  },
  {
    path: "/app/*",
    element: (
      <ProtectedRoute>
        <Suspense fallback={<></>}>
          <RoutesLazy />
        </Suspense>
      </ProtectedRoute>
    ),
  },
  {
    path: "*",
    element: <UnknownPathRedirect />,
  },
]);

const RouteLayout: FC = () => {
  return <RouterProvider router={router} />;
};

export default RouteLayout;
